import { Button, Switch } from "../../components/common";
import {
  ChangePasswordModal,
  TfaModal,
  VerifyModal,
} from "../../components/modals";
import { User, EnableTfaPayload } from "../../types/UserTypes";

export const securityList = (
  user: User,
  disableTfa: (obj: EnableTfaPayload) => void
) => {
  return [
    {
      id: "password",
      icon: "Password",
      value: "Password",
      action: (
        <ChangePasswordModal>
          {(action) => (
            <Button
              variant={Button.variant.TERTIARY}
              className="ml-auto !p-2 !md:p-4"
              onClick={action}
            >
              Change
            </Button>
          )}
        </ChangePasswordModal>
      ),
    },
    {
      id: "2fa",
      icon: "FA",
      value: "Two-factor verification",
      action: user.is_2fa_enabled ? (
        <VerifyModal action={disableTfa}>
          {(action) => (
            <Switch
              id="2fa-disable"
              className="ml-auto !p-2 !md:p-4"
              checked={user.is_2fa_enabled}
              onChange={action}
            />
          )}
        </VerifyModal>
      ) : (
        <TfaModal>
          {(action) => (
            <Switch
              id="2fa-enable"
              className="ml-auto !p-2 !md:p-4"
              checked={user.is_2fa_enabled}
              onChange={action}
            />
          )}
        </TfaModal>
      ),
    },
  ];
};
